import { render, staticRenderFns } from "./ConfusionMatrix.vue?vue&type=template&id=10aaae1b&scoped=true"
import script from "./ConfusionMatrix.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaae1b",
  null
  
)

export default component.exports